export var Emotion;
(function (Emotion) {
    Emotion["great"] = "1";
    Emotion["good"] = "2";
    Emotion["okay"] = "3";
    Emotion["bad"] = "4";
    Emotion["terrible"] = "5";
})(Emotion || (Emotion = {}));
export var EMOTIONS = [
    Emotion.great,
    Emotion.good,
    Emotion.okay,
    Emotion.bad,
    Emotion.terrible
];
